 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/Title'
 import A7815040848951 from '@/components/9781504084895-1'
 import A78150408489531 from '@/components/9781504084895-31'
 import A78150408489532 from '@/components/9781504084895-32'
 import A78150408489533 from '@/components/9781504084895-33'
 import A78150408489534 from '@/components/9781504084895-34'
 import A78150408489535 from '@/components/9781504084895-35'
 import A78150408489536 from '@/components/9781504084895-36'
 import A78150408489537 from '@/components/9781504084895-37'
 import A78150408489538 from '@/components/9781504084895-38'
 import A78150408489539 from '@/components/9781504084895-39'
 import A78150408489540 from '@/components/9781504084895-40'
 import A78150408489541 from '@/components/9781504084895-41'
 import A78150408489542 from '@/components/9781504084895-42'
 import A78150408489543 from '@/components/9781504084895-43'
 import A78150408489544 from '@/components/9781504084895-44'
 import A78150408489545 from '@/components/9781504084895-45'
 import A78150408489546 from '@/components/9781504084895-46'
 import A78150408489547 from '@/components/9781504084895-47'
 import A78150408489548 from '@/components/9781504084895-48'
 import A78150408489549 from '@/components/9781504084895-49'
 import A78150408489550 from '@/components/9781504084895-50'
 import A78150408489551 from '@/components/9781504084895-51'
 import A78150408489552 from '@/components/9781504084895-52'
 import A78150408489553 from '@/components/9781504084895-53'
 import A78150408489554 from '@/components/9781504084895-54'
 import A78150408489555 from '@/components/9781504084895-55'
 import LOVE_2 from '@/components/love_2'
 import A78150408489556 from '@/components/9781504084895-56'
 import A78150408489557 from '@/components/9781504084895-57'
 import A78150408489558 from '@/components/9781504084895-58'
 import COPYRIGHT from '@/components/copyright'
 import SERIESBACKAD from '@/components/seriesbackad'
 import ORIMAD from '@/components/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/tlu",
 			"name" : "tlu",
 			"component" : TLU
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Title",
 			"name" : "Title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/9781504084895-1",
 			"name" : "9781504084895-1",
 			"component" : A7815040848951
 		},
 		{
 			"path" : "/9781504084895-31",
 			"name" : "9781504084895-31",
 			"component" : A78150408489531
 		},
 		{
 			"path" : "/9781504084895-32",
 			"name" : "9781504084895-32",
 			"component" : A78150408489532
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js